import React, { useEffect, useState } from "react";
// products images
import Navbar from "./Navbar";
import Footer from "./Footer";
import swal from "sweetalert";
import axios from "axios";
import Loader from "../Loader";
import Cartempty from "../../Assets/images/no-product.png";
import { useNavigate } from "react-router-dom";
import NoImg from "../../Assets/images/No-Image-Placeholder.svg.png";
import config from "../../Config";
import CartBG from "../../Assets/images/cart_background.jpg";
import { BsCalendar, BsCalendar4 } from "react-icons/bs";
import { FaMinus, FaPlus } from "react-icons/fa";

const Cart = () => {
  const [data, setData] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [quantity, setQuantity] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("items")) || [];
    // add qty = 1 if not already present
    const updated = stored.map((item) => ({
      ...item,
      qty: item.qty || 1,
    }));
    setData(updated);
    setQuantity(updated.map((item) => item.qty)); // keep synced
    setClicked(false);
  }, [clicked]);
  // const data =

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let ColumnTotal = 0;
  data?.forEach((item) => {
    const itemTotal = parseFloat(item.price) * item.qty;
    ColumnTotal += itemTotal;
  });
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();

  const onAddToCart = () => {
    if (!data || data.length === 0) return;

    // Build query params
    // const query = data
    //   .map(
    //     (item) => `add-to-cart=${item.id}&quantity=${item.qty || 1}` // default qty = 1
    //   )
    //   .join("&");

    const ids = data.map((item) => item.id).join(",");
    const quantities = data
      .map((item) => `&quantity[${item.id}]=${item.qty || 1}`)
      .join("");

    const query = `add-to-cart=${ids}${quantities}`;

    // Final checkout URL
    const checkoutURL = `https://myhometurf.com.au/checkout/?${query}`;

    // Show confirmation popup
    swal({
      text: "Would you like to continue shopping or proceed to checkout?",
      icon: "success",
      buttons: {
        cancel: {
          text: "Continue Shopping",
          value: "continue",
          visible: true,
          className: "btn-green",
        },
        confirm: {
          text: "Proceed to Checkout",
          value: "checkout",
        },
      },
    }).then((value) => {
      if (value === "checkout") {
        window.location.href = checkoutURL;
      }
      // if "continue", do nothing → popup will just close
    });
  };

  const handleRemove = (index) => {
    const updated = [...data];
    updated.splice(index, 1);
    setData(updated);
    localStorage.setItem("items", JSON.stringify(updated));
    setClicked(true);
  };

  // Update quantity
  const handleQuantityChange = (index, type) => {
    const updatedQty = [...quantity];

    if (type === "inc") {
      updatedQty[index] += 1;
    } else if (type === "dec" && updatedQty[index] > 1) {
      updatedQty[index] -= 1;
    }

    setQuantity(updatedQty);

    // also update data with new qty
    const updatedData = [...data];
    updatedData[index] = { ...updatedData[index], qty: updatedQty[index] };

    setData(updatedData);
    localStorage.setItem("items", JSON.stringify(updatedData));

    setClicked(true);
  };

  return (
    <>
      {isLoading && <Loader />}
      <Navbar />
      <div className="pt-5">
        <div className="cart-image">
          <img src={CartBG} className="w-100 object-fit-cover" />
        </div>
        <div className="container-box overflow-auto h-100 cart-main">
          <div className="cart-inner-div">
            <nav class="woocommerce-breadcrumb mb-3" aria-label="Breadcrumb">
              <a href="/shop/" className="shoplink">
                Shop
              </a>
              &nbsp;/&nbsp;Cart
            </nav>
            <h1
              className="text-start mb-4"
              style={{ color: "#1c3625", fontWeight: "400" }}
            >
              Cart
            </h1>
            <p className="py-2 text-muted">
              <strong>
                ***Limited time offer***&nbsp; Get a free pair of Gardening
                Gloves with every purchase!
              </strong>
            </p>
            {data?.length >= 1 ? (
              <div className="cart-page container my-5">
                {/* Desktop Table */}
                <table className="table d-none d-md-table border">
                  <thead>
                    <tr>
                      <th style={{ width: "40%" }}>Product</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, i) => (
                      <tr key={i}>
                        {/* Product */}
                        <td className="d-flex gap-2">
                          <button
                            className="btn text-dark me-2 p-0 fs-6 fw-bold"
                            onClick={() => handleRemove(i)}
                          >
                            ✕
                          </button>
                          <img
                            src={item?.images?.[0]?.src}
                            alt="product"
                            width="70"
                            height="90"
                            className="border rounded me-2"
                          />
                          <a
                            href={item?.permalink}
                            className="fw-semibold"
                            style={{ color: "#00a499" }}
                          >
                            {item?.name}
                          </a>
                        </td>

                        {/* Price */}
                        <td>${item?.price}</td>

                        {/* Quantity */}
                        <td>
                          <div className="d-flex align-items-center">
                            <button
                              className="btn color-green rounded-circle px-2 py-1 me-2"
                              onClick={() => handleQuantityChange(i, "dec")}
                            >
                              <FaMinus size={12} />
                            </button>
                            <span className="fw-bold color-green px-4 py-1 rounded-4">
                              {item?.qty}
                            </span>
                            <button
                              className="btn color-green rounded-circle px-2 py-1 ms-2"
                              onClick={() => handleQuantityChange(i, "inc")}
                            >
                              <FaPlus size={12} />
                            </button>
                          </div>
                        </td>

                        {/* Subtotal */}
                        <td>${(item?.price * quantity[i]).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Mobile Table (stacked) */}
                <div className="d-block d-md-none">
                  {data?.map((item, i) => (
                    <table key={i} className="table border mb-3">
                      <tbody>
                        <tr>
                          <td>
                            <strong>Product:</strong>
                          </td>
                          <td>
                            <button
                              className="btn text-dark me-2 p-0 fs-6 fw-bold"
                              onClick={() => handleRemove(i)}
                            >
                              ✕
                            </button>
                            <a
                              href={item?.permalink}
                              className="fw-semibold"
                              style={{ color: "#00a499" }}
                            >
                              {item?.name}
                            </a>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <strong>Price:</strong>
                          </td>
                          <td>${item?.price}</td>
                        </tr>

                        <tr>
                          <td>
                            <strong>Quantity:</strong>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="btn color-green rounded-circle px-2 py-1 me-2"
                                onClick={() => handleQuantityChange(i, "dec")}
                              >
                                <FaMinus size={12} />
                              </button>
                              <span className="fw-bold color-green px-4 py-2 rounded-4">
                                {item?.qty}
                              </span>
                              <button
                                className="btn color-green rounded-circle px-2 py-1 ms-2"
                                onClick={() => handleQuantityChange(i, "inc")}
                              >
                                <FaPlus size={12} />
                              </button>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <strong>Subtotal:</strong>
                          </td>
                          <td>${(item?.price * quantity[i]).toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  ))}
                </div>

                {/* Coupon + Totals remain same */}
                <div className="d-flex justify-content-between align-items-center flex-wrap border p-3 rounded-0">
                  {/* <div className="d-flex align-items-start align-items-md-center mb-3 mb-md-0">
                    <input
                      type="text"
                      className="form-control me-2 mb-2 mb-md-0 px-3 py-2 rounded-0"
                      placeholder="Coupon code"
                      style={{
                        maxWidth: "140px",
                        fontSize: "14px",
                        backgroundColor: "#e6e7e8",
                      }}
                    />
                    <button
                      className="btn btn-secondary ms-1 rounded-0 border border-none px-3 py-2"
                      style={{ backgroundColor: "#bcbec0", fontSize: "14px" }}
                    >
                      APPLY COUPON
                    </button>
                  </div> */}
                  <a
                    href="https://www.myhometurf.com.au/shop/"
                    className="text-decoration-none"
                    style={{ color: "#84bd00" }}
                  >
                    Continue Shopping
                  </a>
                  <div>
                    <button className="btn checkout-btn text-white fw-semibold px-4 mt-3 mt-md-0">
                      UPDATE CART
                    </button>
                  </div>
                </div>

                {/* Totals */}
                <div className="row mt-4">
                  <div className="col-md-6"></div>
                  <div className="col-md-6">
                    <div className="cart-totals-table">
                      <table className="table border">
                        <tbody>
                          <tr>
                            <td>
                              <h6>Subtotal</h6>
                            </td>
                            <td>${ColumnTotal.toFixed(2)}</td>
                          </tr>
                          <tr className="total-row">
                            <td>
                              <h6>Total</h6>
                            </td>
                            <td
                              className="fw-bold"
                              style={{ color: "#00a499" }}
                            >
                              ${ColumnTotal.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <button
                        className="btn py-2 text-white rounded-5 fw-bold w-100"
                        style={{ backgroundColor: "#00a499" }}
                        onClick={onAddToCart}
                      >
                        PROCEED TO CHECKOUT
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-start">
                <div class="woocommerce">
                  <div class="wc-empty-cart-message">
                    <div class="cart-empty woocommerce-info">
                      <BsCalendar size={16} className="me-3" color="#84bd00" />
                      <span>Your cart is currently empty. </span>
                    </div>
                  </div>{" "}
                  <p class="return-to-shop">
                    <a
                      class="button wc-backward"
                      href="https://www.myhometurf.com.au/shop/"
                    >
                      Return to shop{" "}
                    </a>
                  </p>
                </div>
              </div>
            )}{" "}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Cart;
